import { useErrorContext } from 'commons/containers/ValidationErrorManager';
import { ValidationError } from 'craft/types';

export const useValidationError = (nodeIds: string[] | undefined): ValidationError | undefined => {
  const errors = useErrorContext();
  if (!nodeIds) {
    return undefined;
  }
  // this is a slighly naive version.
  // given a set of node ids, it only returns the first error that it finds for that selection.
  return errors.errors.find((error: ValidationError) => nodeIds.indexOf(error.nodeId) > -1);
};

export const useValidationErrorForField = (
  nodeIds: string[] | undefined,
  field: string,
): ValidationError | undefined => {
  const error = useValidationError(nodeIds);
  if (!error || error?.details?.field !== field) {
    return undefined;
  }
  return error;
};
